<template>
  <lazy-div>
    <message :messages="messages"></message>
    <v-container fluid grid-list-sm>
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-list-bulleted</v-icon>
          <v-toolbar-title class="body-2">Claimants List</v-toolbar-title>
        </v-toolbar>
        <v-container fluid grid-list-sm>
          <v-data-table v-bind:headers="claimantColumns" :items="claimForm.claimants" class="elevation-1" :loading="loading">
            <template v-slot:item="row"
              ><tr>
                <td>{{ row.index + 1 }}</td>
                <td>{{ row.item.clmtName }}</td>
                <td>{{ row.item.clmtType + ' - ' + getClaimTypeVal(row.item.clmtType) }}</td>
                <td>{{ checkValue(getItemValue(row.item.clmStat, claimStatList).label) }}</td>
                <td>{{ getCauseStat(row.item.clmStat, row.item.cseStat).label }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQueryClaimant(row)"></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-container>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card v-if="show">
        <v-layout row wrap>
          <v-toolbar v-if="claimant.clmtNo !== undefined" dense color="grey lighten-3" flat>
            <v-icon>mdi-magnify</v-icon>
            <v-toolbar-title class="body-2">Claimant No. {{ claimant.clmtNo + 1 }} - {{ claimant.clmtName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="this.commonInfo.clmEvent">Claim Event No. {{ this.commonInfo.clmEvent }}</v-toolbar-title>
            <v-btn text icon @click="doClose('claimant')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">Claimant No.</v-subheader>
                <span class="queryValue">{{ checkValue(padString(claimant.clmtNo, 5)) }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Claims Status</v-subheader>
                <span class="queryValue">{{ checkValue(getItemValue(claimant.clmStat, claimStatList).label) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Cause of Status</v-subheader>
                <span class="queryValue">{{ checkValue(getItemValue(claimant.cseStat, causeStatList).label) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Claimant Type</v-subheader>
                <span class="queryValue">{{ checkValue(getItemValue(claimant.clmtType, clmtTypeList).label) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Title</v-subheader>
                <span class="queryValue">{{ getItemValue(claimant.titleName, salutationList).label }}</span>
              </v-flex>
              <v-flex lg8 md8 xs12>
                <v-subheader class="queryLabel">Name</v-subheader>
                <span class="queryValue">{{ claimant.clmtName }} {{ claimant.clmtName2 }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Address</v-subheader>
                <span class="queryValue">{{ claimant.addr1 }} {{ claimant.addr2 }} {{ claimant.addr3 }} {{ claimant.addr4 }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Postal Code</v-subheader>
                <span class="queryValue">{{ checkValue(claimant.postCode) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">NRIC No. </v-subheader>
                <span class="queryValue">{{ checkValue(claimant.icNo) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Other</v-subheader>
                <span class="queryValue">{{ checkValue(claimant.othNo) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12 v-if="claimant">
                <v-subheader class="queryLabel">Vehicle Reg No.</v-subheader>
                <span class="queryValue">{{ checkValue(claimant.vehRegNo) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">Vessel No.</v-subheader>
                <span class="queryValue">{{ checkValue(claimant.vesName) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">TP Date of Notification</v-subheader>
                <span class="queryValue">{{ checkValue(formatDate(claimant.tpNotDate)) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Date of Offer</v-subheader>
                <span class="queryValue">{{ checkValue(formatDate(claimant.offrDate)) }}</span>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">Date Agreed</v-subheader>
                <span class="queryValue">{{ checkValue(formatDate(claimant.agmtDate)) }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-layout>
      </v-card>
      <v-card v-if="show">
        <v-container fluid grid-list-sm>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-list-bulleted</v-icon>
            <v-toolbar-title class="body-2">Claim Items List</v-toolbar-title>
          </v-toolbar>
          <v-data-table v-bind:headers="clmItemColumns" :items="claimant.clmItems" class="elevation-1">
            <template v-slot:item="row"
              ><tr>
                <td>{{ row.item.clmtNo }}</td>
                <td>{{ row.index + 1 }}</td>
                <td>{{ claimant.clmtName }}</td>
                <td>{{ getNol1Desc(row.item.nol1).label }}</td>
                <td>{{ getNol2Desc(row.item.nol2).label }}</td>
                <td>{{ row.item.lossDesc1 }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQueryClaimItem(row)" :loading="loading"></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-container>
      </v-card>
      <v-dialog v-model="showItem" width="1020px" persistent>
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-magnify </v-icon>
            <v-toolbar-title>Claimant / Claim Item No.: {{ padString(claimant.clmtNo, 5) + ' / ' + padString(clmItem.clmItem, 2) }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark type="submit" @click.prevent="doExport_ClmFaceSht(commonInfo.clmNo)">
              Print Claim Facesheet
              <v-icon right dark>mdi-printer</v-icon>
            </v-btn>
            <v-toolbar-title class="ml-3 pa-0" v-if="claimant.agmtDate">Date Agreed: {{ formatDate(claimant.agmtDate) }}</v-toolbar-title>
            <v-btn text icon @click="doClose('item')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="height: 600px; overflow-y: scroll">
            <v-layout class="mt-3" row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Risk Group / Risk No. / Item No.:</v-subheader>
                <span class="queryValue">{{ commonInfo.riskGrpNo }} / {{ commonInfo.riskNo }} / {{ clmItem.itemNo }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Claimant Name</v-subheader>
                <span class="queryValue">{{ claimant.clmtName }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Nature of Loss 1</v-subheader>
                <span class="queryValue">{{ clmItem.nol1 }} - {{ clmItem.nol1Desc }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Nature of Loss 2</v-subheader>
                <span class="queryValue">{{ clmItem.nol2 }} - {{ clmItem.nol2Desc }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Description of Loss</v-subheader>
                <span class="queryValue">{{ clmItem.lossDesc1 }}</span> <br />
                <span class="queryValue">{{ clmItem.lossDesc2 }}</span> <br />
                <span class="queryValue">{{ clmItem.lossDesc3 }}</span> <br />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Sum Insured Currency</v-subheader>
                <span class="queryValue">{{ clmItem.siCurr }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Sum Insured</v-subheader>
                <span class="queryValue">{{ formatDisplayNumber(clmItem.si, 2) }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Reserve Currency</v-subheader>
                <span class="queryValue">{{ clmItem.resCurr }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Exchange Rate</v-subheader>
                <span class="queryValue">{{ formatDisplayNumber(clmItem.exRate, 7) }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Applied Excess Currency</v-subheader>
                <span class="queryValue">{{ clmItem.dedCurr }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Applied Excess</v-subheader>
                <span class="queryValue">{{ formatDisplayNumber(clmItem.dedAmt, 2) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">Applied Excess Local</v-subheader>
                <span class="queryValue">{{ formatDisplayNumber(clmItem.dedAmtLoc, 2) }}</span>
              </v-flex>
            </v-layout>
            <v-spacer class="mt-4"></v-spacer>
            <v-layout row wrap>
              <v-flex xs12>
                <v-expansion-panels v-model="panel1" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div xs12><v-icon>mdi-worker</v-icon><span class="headerTitle">Service Providers</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-5 elevation-2">
                      <v-card>
                        <v-card-text>
                          <v-data-table
                            class="elevation-1"
                            :items="clmItem.servicers"
                            v-bind:headers="serviceHeaders"
                            v-if="servicerLayer"
                          >
                            <template v-slot:item="row"
                              ><tr>
                                <td>{{ row.item.interGrpName }}</td>
                                <td>{{ row.item.interName }}</td>
                                <td>{{ row.item.curr }}</td>
                                <td class="text-right">{{ formatNumber(Number(row.item.amt), 2) }}</td>
                                <td class="text-right">{{ formatNumber(Number(row.item.locAmt), 2) }}</td>
                              </tr></template
                            >
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels v-model="panel2" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-layers</v-icon><span class="headerTitle">Reserves</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-data-table
                            v-show="baseCurrSwitch_original"
                            class="elevation-1"
                            :items="clmItem.clmAccumRes"
                            :headers="reserveHeaders"
                            v-if="reserveLayer"
                            item-key="clmResCat"
                          >
                            <template v-slot:item="row"
                              ><tr>
                                <td>{{ row.item.clmResCatDisplay }}</td>
                                <td>{{ row.item.status }}</td>
                                <td class="text-right">{{ clmItem.resCurr }} {{ formatDisplayNumber(row.item.clmResOS, 2) }}</td>
                                <td class="text-right">{{ clmItem.resCurr }} {{ formatDisplayNumber(row.item.plannedRes, 2) }}</td>
                                <td class="text-right">{{ clmItem.resCurr }} {{ formatDisplayNumber(row.item.paidRes, 2) }}</td>
                              </tr></template
                            >
                            <template slot="footer">
                              <v-simple-table>
                                <thead>
                                  <tr style="visibility:collapse">
                                    <th class="text-left">Reserve Categoryb</th>
                                    <th class="text-right" style="padding: 0px 13px">Outstanding Reserveb</th>
                                    <th class="text-right" style="padding: 0px 13px">Planned to Payb</th>
                                    <th class="text-right" style="padding: 0px 13px">Already Paidb</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="text-right">
                                      <strong>Total:</strong>
                                    </td>
                                    <td class="text-right" >{{ clmItem.resCurr }} {{ formatDisplayNumber(clmItem.totResOS, 2) }}</td>
                                    <td class="text-right" >{{ clmItem.resCurr }} {{ formatDisplayNumber(clmItem.totPlannedRes, 2) }}</td>
                                    <td class="text-right" >{{ clmItem.resCurr }} {{ formatDisplayNumber(clmItem.totPaidRes, 2) }}</td>
                                  </tr>
                                </tbody>
                              </v-simple-table>
                            </template>
                          </v-data-table>
                          <v-data-table
                            v-show="!baseCurrSwitch_original"
                            class="elevation-1"
                            :items="clmItem.clmAccumRes"
                            :headers="reserveHeaders"
                            hide-default-footer
                            v-if="reserveLayer"
                            item-key="clmResCat"
                          >
                            <template v-slot:item="row"
                              ><tr>
                                <td>{{ row.item.clmResCatDisplay }}</td>
                                <td>{{ row.item.status }}</td>
                                <td class="text-right">{{ formatDisplayNumber(row.item.clmResOSLoc, 2) }}</td>
                                <td class="text-right">{{ formatDisplayNumber(row.item.plannedLoc, 2) }}</td>
                                <td class="text-right">{{ formatDisplayNumber(row.item.paidLoc, 2) }}</td>
                              </tr></template
                            >
                            <template slot="footer">
                              <v-simple-table>
                                <thead>
                                  <tr style="visibility:collapse">
                                    <th class="text-left">Reserve Categoryb</th>
                                    <th class="text-right" style="padding: 0px 13px">Outstanding Reserveb</th>
                                    <th class="text-right" style="padding: 0px 13px">Planned to Payb</th>
                                    <th class="text-right" style="padding: 0px 13px">Already Paidb</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="text-right">
                                      <strong>Total:</strong>
                                    </td>
                                    <td class="text-right">{{ formatDisplayNumber(clmItem.totResOSLoc, 2) }}</td>
                                    <td class="text-right">{{ formatDisplayNumber(clmItem.totPlannedLoc, 2) }}</td>
                                    <td class="text-right">{{ formatDisplayNumber(clmItem.totPaidLoc, 2) }}</td>
                                  </tr>
                                </tbody>
                              </v-simple-table>
                            </template>
                          </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" type="submit" @click.prevent="doSwitchBaseResCurr">
                            {{ baseCurrSwitch_original ? 'Show in Base Curr' : 'Show in Res. Curr' }}
                            <v-icon right dark>mdi-file-export</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card-text>
        <v-dialog v-model="claimantStatisticsDialog" width="800" persistent>
          <Claim-Statistics :clmtNo="claimant.clmNo" :load="claimantStatisticsDialog" @close="claimantStatisticsDialog = false"></Claim-Statistics>
        </v-dialog>
      </v-card-text>
    </v-container>
  </lazy-div>
</template>

<script>
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { CLAIMS_LIFECYCLE, CLAIMS_CLAIMDETAIL_CLAIMANT } from '@/store/types'
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { isEmptyOrWhiteSpace } from '@/utils/index'
import { salutation, clmtTypeList } from '@/const/claims'
import ClaimStatistics from '@/components/core/claimManagement/sideFunction/ClaimStatistics'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { formatDisplayNumber } from '@/utils/number'

import clone from 'clone'
export default {
  data() {
    return {
      show: false,
      showItem: false,
      back: false,
      claimantStatisticsDialog: false,
      claimForm: {
        selectedClaimant: undefined
      },
      claimant: {
        clmtNo: undefined,
        clmStat: undefined,
        cseStat: undefined,
        clmtType: undefined,
        titleName: undefined,
        clmtName: undefined,
        clmtName2: undefined,
        icNo: undefined,
        othNo: undefined,
        clmtRocUen: undefined,
        clmtDob: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        addr5: undefined,
        addr6: undefined,
        postCode: undefined,
        vehRegNo: undefined,
        vesNo: undefined,
        tpNotDate: undefined,
        offrDate: undefined,
        agmtDate: undefined,
        clmItems: []
      },
      claimStatList: [],
      causeStatList: [],
      defCauseStatList: [],
      appPostalCodeLoading: false,
      postCodeDialog: false,
      addrFound: false,
      countryLoading: false,
      countryList: [],
      clmItemColumns: [
        { text: 'Claimant No.', align: 'left', sortable: false, value: 'clmtNo' },
        { text: 'Claim Item No.', sortable: false, value: 'clmItem' },
        { text: 'Claimant Name', sortable: false, value: 'clmName' },
        { text: 'Nature of Loss 1', sortable: false, value: 'nol1' },
        { text: 'Nature of Loss 2', sortable: false, value: 'nol2' },
        { text: 'Loss Description', sortable: false, value: 'lossDesc1' },
        TableConst.tableActionHeader
      ],
      clmItem: {
        clmtNo: undefined,
        clmItem: undefined,
        itemNo: undefined,
        lossDesc1: undefined,
        lossDesc2: undefined,
        lossDesc3: undefined,
        nol1: undefined,
        nol2: undefined,
        nol1Desc: undefined,
        nol2Desc: undefined,
        siCurr: undefined,
        si: undefined,
        resCurr: undefined,
        exRate: undefined,
        dedCurr: undefined,
        dedAmt: undefined,
        dedAmtLoc: undefined,
        totAmtServicer: undefined,
        totLocAmtServicer: undefined,
        totAccumResLoc: undefined,
        totPaid: undefined,
        totPlanned: undefined,
        totPaidLoc: undefined,
        totPlannedLoc: undefined,
        totAccumRes: undefined,
        itemTxt: undefined,
        servicers: [],
        clmItemReserves: [],
        clmAccumRes: []
      },
      currentResCatList: [],
      serviceHeaders: [
        { text: 'Servicer Group', align: 'left', value: 'interGrpName' },
        { text: 'Servicer', align: 'left', value: 'interName' },
        { text: 'Currency', align: 'left', value: 'curr' },
        { text: 'Amount', align: 'right', value: 'amt' },
        { text: 'Local Amount', align: 'right', value: 'locAmt' }
      ],
      reserveHeaders: [
        { text: 'Reserve Category', align: 'left', value: 'clmResCat' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Outstanding Reserve', align: 'right', value: 'clmResOS' },
        // { text: 'Outstanding Local Reserve', align: 'right', value: 'clmResLocOS' },
        { text: 'Planned to Pay', align: 'right', value: 'planned' },
        { text: 'Already Paid', align: 'right', value: 'paid' }
      ],
      servicerLayer: true,
      reserveLayer: true,
      clmFaceShtForm: {
        clmNo: undefined,
        format: 'PDF',
        sendEmail: false
      },
      baseCurrSwitch_original: true,
      nol1List: [],
      nol2DefList: [],
      nol2List: [],
      panel1: [0],
      panel2: [0],
      currentClmItems: []
    }
  },
  methods: {
    padString(no, length) {
      no += 1
      if (no) {
        return no.toString().padStart(length, '0')
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('claimEntryInit')])
      this.loading = true
      if (this.initClaimDetail === 1) {
        this.getCountryList()
        this.getClaimStats().then(() => {
          this.selectedClaimant = clone(this.commonInfo.selectedClaimant)
          this.loading = false
        })
        this.claimForm = clone(this.commonInfo)
        this.doFetchNOL()
      }
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('claimReportsInit')])
    },
    checkValue(data) {
      if (isEmptyOrWhiteSpace(data)) {
        return ''
      } else {
        return data
      }
    },
    getClaimTypeVal(val) {
      if (val && clmtTypeList[val]) {
        return clmtTypeList[val]
      }
      return ''
    },
    getCauseStat(keyStat, keyCse) {
      for (let param of this.defCauseStatList) {
        if (param.value === keyCse && param.secondaryValue === keyStat) {
          return param
        }
      }
      return {}
    },
    getNol1Desc(key) {
      for (let paramNol1 of this.nol1List) {
        if (paramNol1.value === key) {
          return paramNol1
        }
      }
      return ''
    },
    getNol2Desc(key2) {
      for (let paramNol2 of this.nol2DefList) {
        if (paramNol2.value === key2) {
          return paramNol2
        }
      }
      return ''
    },
    doQueryClaimant(row) {
      this.doCauseList(row.item.clmStat)
      // Init the Claimant details
      this.claimant.clmtNo = row.index
      this.claimant.clmtType = row.item.clmtType
      this.claimant.titleName = row.item.titleName
      this.claimant.clmtName = row.item.clmtName
      this.claimant.clmtName2 = row.item.clmtName2
      this.claimant.icNo = row.item.icNo
      this.claimant.othNo = row.item.othNo
      this.claimant.addr1 = row.item.addr1
      this.claimant.addr2 = row.item.addr2
      this.claimant.addr3 = row.item.addr3
      this.claimant.addr4 = row.item.addr4
      this.claimant.addr5 = row.item.addr5
      this.claimant.addr6 = row.item.addr6
      this.claimant.postCode = row.item.postCode
      this.claimant.vehRegNo = row.item.vehRegNo
      this.claimant.vesNo = row.item.vesNo
      this.claimant.clmStat = row.item.clmStat
      this.claimant.cseStat = row.item.cseStat
      this.claimant.tpNotDate = row.item.tpNotDate
      this.claimant.agmtDate = row.item.agmtDate
      this.claimant.offrDate = row.item.offrDate
      this.claimant.clmItems = row.item.clmItems
      this.currentClmItems = row.item.clmItems
      this.show = true
    },
    doFetchNol2List(value) {
      this.nol2List = []
      this.nol2DefList.map((item) => {
        if (item.nol1 === value) {
          const nol2 = {
            label: item.label,
            value: item.value
          }
          this.nol2List.push(nol2)
        }
      })
    },
    async doFetchNOL() {
      const apiUrl = this.$store.state.commons.menu.natureOfLoss
      if (apiUrl) {
        try {
          this.natureOfLoss1Loading = true
          const expand = {
            busCls: this.commonInfo.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            data.map((item) => {
              const noL1 = {
                label: item.value + ' - ' + item.label,
                value: item.value
              }
              item.clmNOL2List.map((element) => {
                const nol2 = {
                  value: element.value,
                  nol1: item.value,
                  label: element.value + ' - ' + element.label
                }
                this.nol2DefList.push(nol2)
              })
              this.nol1List.push(noL1)
            })
            this.loading = false
          } else {
            this.$toast.warning('Please configure claim parameters.')
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doQueryClaimItem(row) {
      // this.doCauseList(this.claimant.clmStat)
      // this.dedAmt = row.item.dedAmt
      // this.doFetchNol2List(row.item.nol1)
      // Init the Claimant Item
      this.clmItem.clmtNo = this.claimant.clmtNo
      this.clmItem.clmItem = row.index
      this.clmItem.itemNo = row.item.itemNo
      this.clmItem.nol1 = row.item.nol1
      this.clmItem.nol2 = row.item.nol2
      this.clmItem.lossDesc1 = row.item.lossDesc1
      this.clmItem.lossDesc2 = row.item.lossDesc2
      this.clmItem.lossDesc3 = row.item.lossDesc3
      this.clmItem.siCurr = row.item.siCurr
      this.clmItem.si = row.item.si
      this.clmItem.resCurr = row.item.resCurr
      this.clmItem.exRate = row.item.exRate
      this.clmItem.dedCurr = row.item.dedCurr
      this.clmItem.dedAmt = row.item.dedAmt
      this.clmItem.dedAmtLoc = row.item.dedAmtLoc
      this.clmItem.itemTxt = row.item.itemTxt
      this.clmItem.clmItemReserves = row.item.clmItemReserves
      this.clmItem.servicers = row.item.servicers
      this.clmItem.clmAccumRes = row.item.clmAccumRes
      this.clmItem.totPaid = row.item.totPaid
      this.clmItem.totPaidLoc = row.item.totPaidLoc
      this.clmItem.totPaidRes = row.item.totPaidRes
      this.clmItem.totPlanned = row.item.totPlanned
      this.clmItem.totPlannedLoc = row.item.totPlannedLoc
      this.clmItem.totPlannedRes = row.item.totPlannedRes
      this.clmItem.totResOS = row.item.totResOS
      this.clmItem.totResOSLoc = row.item.totResOSLoc
      // this.$set(this.claimForm.clmItems, this.clmItem.clmItem, clone(this.clmItem))
      // this.claimForm.selectedClmItem = this.clmItem
      // await this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMITEM, this.claimForm)

      // CBO: Following are for nolDesc purpose
      if (this.$store.state.clmNOL1Param.init !== 1) {
        await this.$store.dispatch('clmNOL1ManagementInit')
      }
      const apiURI = this.$store.state.clmNOL1Param.menu.getNol1
      if (apiURI) {
        try {
          const expand = { nol1: row.item.nol1 }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.clmItem.nol1Desc = data.clmNol1.nol1longDesc
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      if (this.$store.state.clmNOL2Param.init !== 1) {
        await this.$store.dispatch('clmNOL2ManagementInit')
      }
      const apiURI2 = this.$store.state.clmNOL2Param.menu.getNol2
      if (apiURI2 && row.item.nol2) {
        const expand = { nol1: row.item.nol1, nol2: row.item.nol2 }
        this.$http
          .get(expandURI(apiURI2, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.clmItem.nol2Desc = data.clmNol2.nol2desc
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
      if (this.$store.state.clsResCatParam.init !== 1) {
        await this.$store.dispatch('clmResCatManagementInit')
      }
      const apiURI3 = this.$store.state.clsResCatParam.menu.getResCat
      // to find clmResCat description
      if (apiURI3) {
        try {
          for (var i = 0; i < row.item.clmAccumRes.length; i++) {
            const expand = { resCat: row.item.clmAccumRes[i].clmResCat }
            const result = await this.$http.get(expandURI(apiURI3, expand))
            const { data } = result.data
            if (data) {
              this.clmItem.clmAccumRes[i].clmResCatDisplay = row.item.clmAccumRes[i].clmResCat + ' - ' + data.clmResCat.resCatLongDesc
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.showItem = true
    },
    async getCountryList() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.countryList
      if (apiUrl) {
        try {
          this.countryLoading = true
          this.countryList = []
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            this.$set(this, 'countryList', result.data.data)
          }
          this.countryLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.countryLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async getClaimStats() {
      const apiURI = this.$store.state.claims.claimRegister.menu.getClaimStats
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.claimStatList = []
          this.defCauseStatList = []
          if (data) {
            data.map((item) => {
              const claimStat = {
                value: item.clmStat,
                label: item.clmStatDesc
              }
              item.clmStatCauseList.map((element) => {
                const causeStat = {
                  value: element.value,
                  secondaryValue: element.secondaryValue,
                  label: element.label
                }
                this.defCauseStatList.push(causeStat)
              })
              this.claimStatList.push(claimStat)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCauseList(value) {
      this.causeStatList = []
      this.defCauseStatList.map((item) => {
        if (item.secondaryValue === value) {
          const causeStat = {
            label: item.label,
            value: item.value
          }
          this.causeStatList.push(causeStat)
        }
      })
    },
    doClose(dType) {
      if (dType === 'item') {
        this.showItem = false
      }
      if (dType === 'claimant') {
        this.show = false
        // this.$emit('closeItem')
      }
    },
    async doSaveClaimant() {
      this.$set(this.claimForm.claimants, this.claimant.clmtNo, clone(this.claimant))
      this.claimForm.selectedClaimant = this.claimant
      await this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMANT, this.claimForm)
      this.$store.commit(CLAIMS_LIFECYCLE, 4)
      this.$router.push({ name: 'qClaimItem' })
    },
    async doBack() {
      this.back = true
      this.$store.commit(CLAIMS_CLAIMDETAIL_CLAIMANT, this.claimForm)
      if (this.back) {
        this.$store.commit(CLAIMS_LIFECYCLE, 2)
        this.$router.push({ name: 'qClaimHeader' })
      }
    },
    async doExport_ClmFaceSht(clmNo) {
      const apiURI = this.$store.state.reports.claimReports.menu.export
      if (apiURI) {
        try {
          this.clmFaceShtForm.clmNo = clmNo
          await this.$http.post(apiURI, this.clmFaceShtForm)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSwitchBaseResCurr() {
      this.$nextTick(() => {
        this.baseCurrSwitch_original = !this.baseCurrSwitch_original
      })
    }
  },
  computed: {
    currencyList() {
      return this.$store.state.claims.claimParams.currencyList
    },
    reserveList() {
      return this.$store.state.claims.claimParams.reservesList
    },
    servicerList() {
      return this.$store.state.claims.claimParams.serviceProviderList
    },
    getGrossReserveOS() {
      return this.commonInfo.totResLoc - this.commonInfo.planPaytLoc - this.commonInfo.paidAmtLoc
    },
    getParamReserve(key) {
      for (let paramReserve of this.reserveList) {
        if (paramReserve.value === key) {
          return paramReserve
        }
      }
      return {}
    },
    getCurrency(key) {
      for (let paramCurrency of this.currencyList) {
        if (paramCurrency.value === key) {
          return paramCurrency
        }
      }
      return {}
    },
    getParamServicer(key) {
      for (let paramServicer of this.servicerList) {
        if (paramServicer.value === key) {
          return paramServicer
        }
      }
      return {}
    },
    claimantColumns() {
      return [
        { text: 'Claimant No.', align: 'left', sortable: false, value: 'clmtNo' },
        { text: 'Claimant Name', align: 'left', sortable: false, value: 'clmtName' },
        { text: 'Claimant Type', align: 'left', sortable: false, value: 'clmType' },
        { text: 'Claimant Status', align: 'left', sortable: false, value: 'clmtStat' },
        { text: 'Cause of Status', align: 'left', sortable: false, value: 'cseStat' },
        TableConst.tableActionHeader
      ]
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    clmtTypeList() {
      let result = []
      Object.keys(clmtTypeList).forEach(function (key) {
        const status = clmtTypeList[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    initClaimDetail() {
      return this.$store.state.claims.claimDetail.init
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    ClaimStatistics
  },
  mixins: [MessageMixin, ClaimCommonMixin, routeMixin, TableConst.default]
}
</script>

<style>
</style>
